// Aviso (>= 80%) e bloqueio (100%) da franquia do Free.
//
// Fica no AppShell, junto dos outros banners globais, porque o estado precisa
// aparecer em TODA tela onde a pessoa tentaria enviar — Dashboard, Inbox,
// Campanhas, Playground. Só o Free com franquia vê: Pro e cortesia são
// ilimitados e o componente não renderiza nada para eles.
//
// O tom é deliberadamente calmo: nada está quebrado, e o que mais importa é a
// pessoa entender que RECEBER continua funcionando.
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Info, PauseCircle, X } from 'lucide-react';

import { useI18n } from '@/lib/i18n';
import { cn } from '@/lib/utils';
import { useFreeQuota } from '@/lib/free-quota';

export function FreeQuotaBanner() {
  const { locale, t } = useI18n();
  const q = useFreeQuota();
  // O aviso é dispensável por sessão; o BLOQUEIO não — enquanto o envio estiver
  // pausado, esconder isso só faria a pessoa achar que o painel está com defeito.
  const [dismissed, setDismissed] = useState(false);

  if (!q.metered) return null;
  const show = q.blocked || (q.warning && !dismissed);
  if (!show) return null;

  const n = (v: number) => v.toLocaleString(locale);
  const resetDate = q.resetsAt.toLocaleDateString(locale, { day: '2-digit', month: 'long' });
  const Icon = q.blocked ? PauseCircle : Info;

  return (
    <div
      className={cn(
        'mb-4 flex flex-col gap-3 rounded-lg border p-3 text-sm sm:flex-row sm:items-start',
        q.blocked
          ? 'border-destructive/30 bg-destructive/5'
          : 'border-amber-300 bg-amber-50 dark:border-amber-800 dark:bg-amber-950/40',
      )}
    >
      <Icon className={cn('mt-0.5 size-4 shrink-0', q.blocked ? 'text-destructive' : 'text-amber-600 dark:text-amber-400')} />
      <div className="min-w-0 flex-1">
        <p className={cn('font-semibold', q.blocked ? 'text-destructive' : 'text-amber-900 dark:text-amber-200')}>
          {q.blocked ? t('freeQuota.blockedTitle') : t('freeQuota.warnTitle')}
        </p>
        <p className={cn(q.blocked ? 'text-destructive/90' : 'text-amber-800 dark:text-amber-300/90')}>
          {q.blocked
            ? t('freeQuota.blockedBody', { included: n(q.included), date: resetDate })
            : t('freeQuota.warnBody', { used: n(q.used), included: n(q.included) })}
        </p>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        <Link
          to="/billing"
          className={cn(
            'rounded-md px-2.5 py-1 text-xs font-semibold text-white',
            q.blocked ? 'bg-destructive' : 'bg-amber-600',
          )}
        >
          {t('freeQuota.upgrade')}
        </Link>
        {!q.blocked && (
          <button
            onClick={() => setDismissed(true)}
            className="rounded p-0.5 opacity-60 transition-opacity hover:opacity-100"
            aria-label={t('freeQuota.dismiss')}
          >
            <X className="size-4" />
          </button>
        )}
      </div>
    </div>
  );
}
